import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     width: '100%',
    //     backgroundColor: theme.palette.background.paper,
    // },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function IncomeTaxPassword() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [provide, setprovide] = useState('provide');
    const [available, setAvailable] = useState('none');
    const [lost, setLost] = useState('none');
    const [formValues, setformValues] = React.useState({
        incomeUserId: 'Enter User ID',
        incomePassword: 'Enter Password',
    });
    const handleRoleChange = (event) => {
        setAvailable(event.target.value);

        switch (event.target.value) {
            case 'available':
                // setAvailable('block');
                setprovide('none');
                // setLost('none');
                //console.log('expenditure');

                return true;
            case 'provide':
                setprovide('block');
                // setAvailable('none');
                // setLost('none');
                //console.log('records');
                return true;
            case 'lost':
                // setLost('block');
                // setAvailable('none');
                setprovide('none');
                //console.log('banksAcc');
                return true;
            default:
                return true;
        }
    };
    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={12}>
                <FormControl component="fieldset">
                    <RadioGroup defaultValue="provide" aria-label="business" name="customized-radios" onChange={handleRoleChange} className="radio-option">
                        <ul className={classes.expenditure}>
                            <li>
                                <FormControlLabel value="available" control={<StyledRadio />} label="Should be available with you" />
                            </li>
                            <li>
                                <FormControlLabel value="provide" control={<StyledRadio />} disabled label="Would like to provide the same now" className="cursor-default" />
                            </li>
                            <li>
                                <FormControlLabel value="lost" control={<StyledRadio />} disabled label="Lost / Not created " className="cursor-default" />
                            </li>
                        </ul>
                    </RadioGroup>
                </FormControl>

                <div style={{ display: provide }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className={classes.margin}>
                                <InputLabel htmlFor="user-id">User ID</InputLabel>
                                <Input
                                    disabled
                                    className={classes.bottomLine}
                                    id="user-id"
                                    value={formValues.incomeUserId}
                                // onChange={handleChange('amount')}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className={classes.margin}>
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <Input
                                    disabled
                                    className={classes.bottomLine}
                                    id="password"
                                    value={formValues.incomePassword}
                                // onChange={handleChange('amount')}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
}
